import "./App.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchFeatureFlags } from "./Redux/Slices/featureFlagsSlice";
import SignInFaceRecognition from "./Components/SignInFlow/SignInFaceRecognition/SignInFaceRecognition";
import SingleVote from "./Components/SingleVote/SingleVote";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import SingleShortsVideo from "./Components/SingleShortsVideo/SingleShortsVideo";
import PrivacyPolicy from "./Components/Donation/PrivacyPolicy/PrivacyPolicy";
import GetStartedPage from "./Pages/GetStartedPage/GetStartedPage";
import SignUpGetStarted from "./Components/SignUpGetStarted/SignUpGetStarted";
import SignUpPage from './Pages/SignUpPage/SignUpPage';
import SignInPage from './Pages/SignInPage/SignInPage';
import BallotsPage from "./Pages/BallotsPage/BallotsPage";
import UploadShortsPage from "./Pages/UploadShortsPage/UploadShortsPage";
import AddBallotPage from "./Pages/AddBallotPage/AddBallotPage";
import BallotsHistoryPage from "./Pages/BallotsHistoryPage/BallotsHistoryPage";
import SavedBallotsPage from "./Pages/SavedBallotsPage/SavedBallotsPage";
import ShortsVideoPage from "./Pages/ShortsVideoPage/ShortsVideoPage";
import ProfileDetailsPage from "./Pages/ProfileDetailsPage/ProfileDetailsPage";
import ChangePasswordPage from "./Pages/ChangePasswordPage/ChangePasswordPage";
import TermsOfUse from "./Components/Donation/TermsOfUse/TermsOfUse";
import DonationPage from "./Pages/DonationPage/DonationPage";
import VotingRule from "./Components/Donation/FAQSections/VotingRules/VotingRules";
import AffiliateReferralsPage from "./Pages/AffiliateReferralsPage/AffiliateReferralsPage";
import AffiliateEarningsPage from "./Pages/AffiliateEarningsPage/AffiliateEarningsPage";
import RewardsPage from "./Pages/RewardsPage/RewardsPage";
import MyBallotsPage from "./Pages/MyBallotsPage/MyBallotsPage";
import HelpCenterPage from "./Pages/HelpCenterPage/HelpCenterPage";
import SplashPage from "./Pages/SplashPage/SplashPage";
import PaymentSuccess from "./Pages/PaymentCallback/PaymentSuccess";
import PaymentCancel from "./Pages/PaymentCallback/PaymentCancel";
import AdventurePage from "./Pages/AdventurePage/AdventurePage";
import AdventureDashboardPage from "./Pages/AdventureDashboardPage/AdventureDashboardPage";
import GearPage from "./Pages/GearPage/GearPage";import CertificationsPage from './Pages/CertificationsPage/CertificationsPage';
import CertificationDetailPage from './Pages/CertificationDetailPage/CertificationDetailPage';
import LearningModulesPage from './Pages/LearningModulesPage/LearningModulesPage';
import ExamPage from './Pages/ExamPage/ExamPage';
import ExamResultPage from './Pages/ExamResultPage/ExamResultPage';
import MyCertificatesPage from './Pages/MyCertificatesPage/MyCertificatesPage';
import CertificateDetailPage from './Pages/CertificateDetailPage/CertificateDetailPage';
import OfferingsDashboardPage from './Pages/OfferingsDashboardPage/OfferingsDashboardPage';
import CreateOfferingPage from './Pages/CreateOfferingPage/CreateOfferingPage';
import EditOfferingPage from './Pages/EditOfferingPage/EditOfferingPage';
import OfferingDetailPage from './Pages/OfferingDetailPage/OfferingDetailPage';
import EventDashboardPage from './Pages/EventDashboardPage/EventDashboardPage';
import FulfillmentDashboardPage from './Pages/FulfillmentDashboardPage/FulfillmentDashboardPage';
import OrdersPage from './Pages/OrdersPage/OrdersPage';
import CustomerOrderDetailPage from './Pages/CustomerOrderDetailPage/CustomerOrderDetailPage';
import RequestQuotePage from './Pages/RequestQuotePage/RequestQuotePage';
import QuotesPage from './Pages/QuotesPage/QuotesPage';
import QuoteDetailPage from './Pages/QuoteDetailPage/QuoteDetailPage';
import MarketplacePage from './Pages/MarketplacePage/MarketplacePage';
import ProviderProfilePage from './Pages/ProviderProfilePage/ProviderProfilePage';
import ProviderReviewsPage from './Pages/ProviderReviewsPage/ProviderReviewsPage';
import PayoutSettings from './Pages/PayoutSettings/PayoutSettings';
import WalletPage from './Pages/WalletPage/WalletPage';
import CommunitiesPage from './Pages/CommunitiesPage/CommunitiesPage';
import CommunityDetailPage from './Pages/CommunityDetailPage/CommunityDetailPage';
import RouteTracker from './Components/RouteTracker/RouteTracker';

function App() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Pre-fetch feature flags globally on app load
    dispatch(fetchFeatureFlags());
  }, [dispatch]);

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace("#", "");
      const scrollToHash = () => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          return true;
        }
        return false;
      };

      if (!scrollToHash()) {
        const interval = setInterval(() => {
          if (scrollToHash()) {
            clearInterval(interval);
          }
        }, 100);
        const timeout = setTimeout(() => clearInterval(interval), 2000);
        return () => {
          clearInterval(interval);
          clearTimeout(timeout);
        };
      }
    } else {
      // Scroll to top on route change when no hash anchor is present
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="App">
      <RouteTracker />
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/amalgamate" element={<DonationPage />} />
        <Route path="/facilitate" element={<AdventurePage />} />
        <Route
          path="/facilitate/home"
          element={
            <ProtectedRoute>
              <AdventureDashboardPage />
            </ProtectedRoute>
          }
        />
        {/* Offerings Booking & Marketplace Routes */}
        <Route
          path="/facilitate/marketplace"
          element={
            <ProtectedRoute>
              <MarketplacePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/offerings"
          element={
            <ProtectedRoute>
              <OfferingsDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/offerings/create"
          element={
            <ProtectedRoute>
              <CreateOfferingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/offerings/:id/edit"
          element={
            <ProtectedRoute>
              <EditOfferingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/fulfillment"
          element={
            <ProtectedRoute>
              <FulfillmentDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route path="/facilitate/offerings/:id" element={<OfferingDetailPage />} />
        <Route path="/facilitate/offerings/:id/:slug" element={<OfferingDetailPage />} />
        <Route
          path="/facilitate/events/:id/manage"
          element={
            <ProtectedRoute>
              <EventDashboardPage />
            </ProtectedRoute>
          }
        />
        
        {/* Facilitate Orders Routes */}
        <Route
          path="/facilitate/orders"
          element={
            <ProtectedRoute>
              <OrdersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/orders/:id"
          element={
            <ProtectedRoute>
              <CustomerOrderDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/orders/inbox"
          element={
            <ProtectedRoute>
              <OrdersPage />
            </ProtectedRoute>
          }
        />

        {/* Facilitate Quote Request Routes */}
        <Route
          path="/facilitate/quotes/request/:providerId"
          element={
            <ProtectedRoute>
              <RequestQuotePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/quotes/request"
          element={
            <ProtectedRoute>
              <RequestQuotePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/quotes/inbox"
          element={
            <ProtectedRoute>
              <QuotesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/quotes"
          element={
            <ProtectedRoute>
              <QuotesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/quotes/:id"
          element={
            <ProtectedRoute>
              <QuoteDetailPage />
            </ProtectedRoute>
          }
        />
        <Route path="/facilitate/providers/:id" element={<ProviderProfilePage />} />
        <Route
          path="/facilitate/reviews"
          element={
            <ProtectedRoute>
              <ProviderReviewsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/settings/payouts"
          element={
            <ProtectedRoute>
              <PayoutSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/facilitate/wallet"
          element={
            <ProtectedRoute>
              <WalletPage />
            </ProtectedRoute>
          }
        />
        {/* Backwards-compatibility redirects for old /adventure & /gear routes */}
        <Route path="/adventure" element={<Navigate to="/facilitate" replace />} />
        <Route path="/adventure/home" element={<Navigate to="/facilitate/home" replace />} />
        <Route path="/adventure/marketplace" element={<Navigate to="/facilitate/marketplace" replace />} />
        <Route path="/adventure/offerings" element={<Navigate to="/facilitate/offerings" replace />} />
        <Route path="/adventure/offerings/create" element={<Navigate to="/facilitate/offerings/create" replace />} />
        <Route path="/adventure/offerings/:id/edit" element={<Navigate to="/facilitate/offerings/:id/edit" replace />} />
        <Route path="/adventure/fulfillment" element={<Navigate to="/facilitate/fulfillment" replace />} />
        <Route path="/adventure/offerings/:id" element={<Navigate to="/facilitate/offerings/:id" replace />} />
        <Route path="/adventure/offerings/:id/:slug" element={<Navigate to="/facilitate/offerings/:id/:slug" replace />} />
        <Route path="/adventure/events/:id/manage" element={<Navigate to="/facilitate/events/:id/manage" replace />} />
        <Route path="/adventure/orders" element={<Navigate to="/facilitate/orders" replace />} />
        <Route path="/adventure/orders/:id" element={<Navigate to="/facilitate/orders/:id" replace />} />
        <Route path="/adventure/orders/inbox" element={<Navigate to="/facilitate/orders/inbox" replace />} />
        <Route path="/adventure/quotes" element={<Navigate to="/facilitate/quotes" replace />} />
        <Route path="/adventure/quotes/inbox" element={<Navigate to="/facilitate/quotes/inbox" replace />} />
        <Route path="/adventure/quotes/request" element={<Navigate to="/facilitate/quotes/request" replace />} />
        <Route path="/adventure/quotes/request/:providerId" element={<Navigate to="/facilitate/quotes/request/:providerId" replace />} />
        <Route path="/adventure/quotes/:id" element={<Navigate to="/facilitate/quotes/:id" replace />} />
        <Route path="/adventure/providers/:id" element={<Navigate to="/facilitate/providers/:id" replace />} />
        <Route path="/adventure/reviews" element={<Navigate to="/facilitate/reviews" replace />} />
        <Route path="/adventure/settings/payouts" element={<Navigate to="/facilitate/settings/payouts" replace />} />
        <Route path="/adventure/wallet" element={<Navigate to="/facilitate/wallet" replace />} />
        <Route path="/gear" element={<Navigate to="/educate" replace />} />

        <Route
          path="/payment/success"
          element={
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payment/cancel"
          element={
            <ProtectedRoute>
              <PaymentCancel />
            </ProtectedRoute>
          }
        />
        <Route path="/educate" element={<GearPage />} />
        <Route path="/SignUpGetStarted" element={<SignUpGetStarted />} />
        <Route path="/login" element={<GetStartedPage />} />
        <Route path="/signin-face-recognition" element={<SignInFaceRecognition />} />
        <Route path='/signup' element={<SignUpPage />} />
        <Route path='/signin' element={<SignInPage />} />
        <Route path="/donate/voting-rules" element={<VotingRule />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        {/* Protected Routes */}
        <Route
          path="/ballots"
          element={
            <ProtectedRoute>
              <BallotsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upload-shorts"
          element={
            <ProtectedRoute>
              <UploadShortsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-ballot"
          element={
            <ProtectedRoute>
              <AddBallotPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-ballot"
          element={
            <ProtectedRoute>
              <AddBallotPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ballots-history"
          element={
            <ProtectedRoute>
              <BallotsHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-ballots"
          element={
            <ProtectedRoute>
              <MyBallotsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/saved-ballots"
          element={
            <ProtectedRoute>
              <SavedBallotsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shorts-videos"
          element={
            <ProtectedRoute>
              <ShortsVideoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="basicDetails" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-cover-photo"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editCoverPhoto" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-name"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editName" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/request-status"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="withdrawRequest" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-dob"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editDOB" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-address"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editAddress" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-language"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editLanguage" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-gender"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editGender" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-political-affiliation"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editPoliticalAffiliation" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-details/edit-professions"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="editProfessions" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-completeness"
          element={
            <ProtectedRoute>
              <ProfileDetailsPage activeProfileDetailsComponent="basicDetails" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/affiliate-referrals"
          element={
            <ProtectedRoute>
              <AffiliateReferralsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/affiliate-earnings"
          element={
            <ProtectedRoute>
              <AffiliateEarningsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vote"
          element={
            <ProtectedRoute>
              <SingleVote />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shorts-video"
          element={
            <ProtectedRoute>
              <SingleShortsVideo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rewards"
          element={
            <ProtectedRoute>
              <RewardsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/help-center"
          element={
            <ProtectedRoute>
              <HelpCenterPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/certifications"
          element={
            <ProtectedRoute>
              <CertificationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/certifications/:certificationId"
          element={
            <ProtectedRoute>
              <CertificationDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/certifications/:certificationId/learn"
          element={
            <ProtectedRoute>
              <LearningModulesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/certifications/:certificationId/exam/:applicationId"
          element={
            <ProtectedRoute>
              <ExamPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/certifications/:certificationId/result/:applicationId"
          element={
            <ProtectedRoute>
              <ExamResultPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-certificates"
          element={
            <ProtectedRoute>
              <MyCertificatesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-certificates/:userCertificateId"
          element={
            <ProtectedRoute>
              <CertificateDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/communities"
          element={
            <ProtectedRoute>
              <CommunitiesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/communities/:slug"
          element={
            <ProtectedRoute>
              <CommunityDetailPage />
            </ProtectedRoute>
          }
        />

      </Routes>

    </div>
  );
}

export default App;
